import { Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Input, InputPass, MultiSelect, Select } from "../../../controls";
import { PassValidation } from "../../../utils";
import { AppContext } from "../../../App";
import { action, controller, Server } from "../../../api/Server";

const PermissionsFields = ({
  t,
  values,
  setValues,
  errors,
  handleInpChg,
  handleInpPass,
  storeLi,
  passValid,
  checkUserName,
}) => {
  const { authUser } = useContext(AppContext);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (values.userRoleId === 1) {
      values.role === 1
        ? setValues((j) => ({
            ...j,
            stores: [...storeLi.map((store) => store.id)],
          }))
        : setValues((j) => ({ ...j, stores: [] }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.role]);

  useEffect(() => {
    Server(controller.UserRole + action.GetLabels).get((res) =>
      res?.status === 200
        ? setRoles([...res.result])
        : console.error("UserRole Error:", res.msg)
    );
    return () => {};
  }, []);

  return (
    <>
      <Grid container spacing={2}>
        {authUser.role !== 5 && (
          <Grid item xs={12} md={4}>
            <Select
              required
              label={t("role")}
              name="userRoleId"
              value={values.userRoleId}
              error={errors.userRoleId}
              onChange={handleInpChg}
              fullWidth
              options={roles}
            />
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <MultiSelect
            label={t("store")}
            name="stores"
            required
            value={values.stores}
            error={errors.stores}
            onChange={handleInpChg}
            fullWidth
            options={storeLi || []}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Input
            required
            label={t("userName")}
            name="userName"
            value={values.userName}
            error={errors.userName}
            autoComplete="off"
            onChange={handleInpChg}
            onBlur={(e) => checkUserName(e.target.value)}
            fullWidth
            inputProps={{ maxLength: 400 }}
          />
        </Grid>
        {!values.id && (
          <>
            <Grid item xs={12} md={6}>
              <InputPass
                required
                label={t("password")}
                name="password"
                value={values.password}
                onChange={handleInpPass}
                error={errors.password}
                className="input-primary w-100pr"
              />
              <PassValidation {...{ password: values.password, passValid }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputPass
                required
                label={t("confirmPassword")}
                name="confirmPass"
                value={values.confirmPass}
                onChange={(e) => handleInpPass(e, true)}
                error={
                  errors.confirmPass !== "" &&
                  values.password !== "" &&
                  !passValid.match &&
                  values.confirmPass !== ""
                    ? t("passwordAndConfirmPasswordNotMatch")
                    : errors.confirmPass
                }
                className="input-primary w-100pr"
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default PermissionsFields;
